<template>
      <div class="exams-main" style=" overflow-x: hidden;padding-bottom: 80px;">
        <div class="hasCategory ">
             <div class="exams-panel">
                <div class="exams-panel-body">
                        <div class="table-toolbar flex align-cen" style="margin-bottom:0 !important">
                            <div class="table-toolbar-right  flex align-cen">
                                 <div class="regulaOption flex align-cen">
                                    <el-select v-model="value1"   placeholder="内外部课程"
                                    @change="getList1"
                                    >
                                        <el-option
                                        v-for="item in option1"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                 <div class="regulaOption flex align-cen">
                                    <el-select v-model="value"  clearable placeholder="课程分类"
                                    @change="getList"
                                    >
                                        <el-option
                                        v-for="item in option"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                     <div class="exams-list">
                             <div class="public-tit flex align-cen" style="margin:10px 0px">
                                    <div class="public-tit-list">
                                        <i class="icon-al-file-fill"></i>  全部课程
                                    </div>
                                </div>
                               <div class="product-container  flex align-cen"  v-if="dataList2.length">
                             <div class="product-card"  v-for="item in dataList2"
                             @click="openDetail(item)"
                             >
                                <img :src="item.logo" alt="">
                                  <div class="product-card-item-wrap">
                                    <div class="card-name">{{item.title}}</div>
                                    <div class="card-description">{{item.introduction || '暂无描述'}}</div>
                                    <div class="WordsLink_word-wrap">
                                        <div class="wrap-price">
                                            <div v-if="item.payType == 1" style="color:red">免费</div>
                                            <div v-else class=" flex align-cen">
                                                <div>
                                                        <span style="color:red;font-size:20px">¥{{item.minSale}}起</span> 
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mft wrap-len" style="color:#b4b7c1;font-size:13px">已更新 {{item.chapterNum}}期</div>
                                    </div>
                                </div>
                             </div>
                        </div>
                         <div class="exams-scrollbar" v-else>
                                <el-empty>
                            </el-empty>
                            </div>
                                <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
                     </div>
                </div>
             </div>
        </div>
      </div>
</template>
<script>
import {courseClassify1,bannerList,courseIndexPage1} from "@/api/enterprise/index"   //课程列表、课程轮播图、全部课程分野
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
     components:{
      paginaTion
    },
    data () {
        return {
            value1:0,
            option1:[
                {
                    id:1,
                    name:'平台课程'
                },
                {
                    id:0,
                    name:'企业内部课程'
                }
            ],
         totalCount:0,
            businessInfo:{},
            itemList:[],
            option:[],
            value:'',
            banner:[],
            fristId:'',
             currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            dataList2:[],
        }
    },
    created() {
           if(this.$locaStorage.setAge().get('businessInfo')){
            this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
         }else{
            this.businessInfo = {
                id:this.$route.query.businessId
            }
         }
         this.getBanner()
           //    异步同步执行
            this.getClass()
            this.gethisList()
    },
    methods: {
        getList1(){
            this.getClass()
            this.getList()
        },
                  // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.gethisList()
      },
             gethisList(){
            courseIndexPage1({
                id:'',
                recommend:'',
                classifyId:this.value,
                payType:'',
                size:this.PageSize,
                current:this.currentPage,
                isPlat:this.value1,
                businessId:this.businessInfo.id
            },'enterprise')
            .then(res =>{
                this.dataList2 = res.data.records
                this.totalCount = res.data.total
            })
        },
            // 获取轮播图
        getBanner(){
              bannerList({
              channelFirst:'和隆优化官网',
              channelSecond:'课程首页-网页端'
            },'enterprise')
            .then(res => {
             this.banner = res.data
            })
            .catch(err => {
            })
        },
               // 打开轮播图详情页
        openBannerView(data){
             if(data.particularType == '1'){
                 
                let path=data.particulars
               window.open(path,'_black')
             }else{
                  const newurl = this.$router.resolve({name: 'bannerDetail', query: {id: data.id}})
                    window.open(newurl.href,'_blank')
             }
        },
        openDetail(data){
             const newurl = this.$router.resolve({name: 'HlrjenCourseDetail', query: {id: data.id}})
                    window.open(newurl.href,'_blank')
        },
         // 获取课程分类
            async getClass(){
            await courseClassify1({name:'',isPlat:this.value1,businessId:this.businessInfo.id})
            .then(res =>{
                this.option = res.data
            })
        },
        getList(){
            this.currentPage = 1
            this.gethisList()
        },
    },
}
</script>
<style lang="scss" scoped>
        .banner{
        position: relative;
        .banner-list{
            img{
                object-fit: cover;
            }
        }
        .banner-description{
            position: absolute;
            left: 8%;
            top: 144px;
            color: #fff;
            .name{
               font-size: 42px;
                color: #181818;
                line-height: 48px;
                margin-bottom: 15px;
                opacity: 1;
                min-height: 48px;
            }
            .description{
    height: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    font-size: 16px;
    color: #181818;
    line-height: 30px;
    margin-bottom: 20px;
    opacity: 1;
            }
                .btn{
                     width: 138px;
                    cursor: pointer;
                    border: none;
                   height: 42px;
                   line-height: 42px;
                    font-size: 16px;
                    text-align: center;
                    vertical-align: middle;
                    background-color: #2893f1;
                    border-radius: 1px;
                    margin-right: 20px;
                    padding: 0px 0;
                    color: #fff;
                    a{
                        color: #fff;
                    }
                }
        }
    }
         #banner{
            position: relative;
        .el-carousel__container{
            height: auto;
        }
 
    }
                    .product-container{
                    max-width: 1540px;
            padding: 25px 15px 60px;
            flex-wrap: wrap;
            margin: 0 auto;
                    margin-bottom: 4px;
      .product-card{
        cursor: pointer;
       width: 25%;
    position: relative;
    cursor: pointer;
    margin-top: 27px;
            background-color: #fff;
            box-shadow: 0 4px 20px rgba(19,19,51,0.04);
            border-radius: 4px;
            z-index: 1;
            font-size: 0;
            font-family: Microsoft YaHei;
            font-weight: 400;
            transition: box-shadow .15s;
            img{
                width: 97%;
                height: 150px;
                object-fit: cover;
                border-radius: 4px 4px 0 0;
            }
            .product-card-item-wrap{
             padding: 12px 16px 16px;
             .card-name{
                width: 97%;
                margin-bottom: 2px;
                overflow: hidden;
                color: #161616;
                font-weight: 600;
                font-size: 16px;
                line-height: 26px;
                white-space: nowrap;
                text-overflow: ellipsis;
             }
             .card-description{
                display: -webkit-box;
                margin-bottom: 12px;
                overflow: hidden;
                color: #b4b7c1;
                font-size: 14px;
                line-height: 22px;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
             }
             .WordsLink_word-wrap{
                color: #2893f1;
                font-size: 14px;
                line-height: 22px;
                cursor: pointer;
                span{
                        display: inline-block;
                    font-size: 13px;
                    margin-left: 4px;
                }
             }
            }
      }  
    }
    ::v-deep{
    .fentotl{
        width: 100%;
        .jiange{
            width: 100%;
            text-align: center !important;
        }
    }
    }
</style>